<template>
  <el-form ref="form" :model="filterForm" label-width="100px" :class="$style[classes]">
    <el-form-item label="批量订单号">
      <el-input v-model="filterForm.name"></el-input>
    </el-form-item>
    <el-form-item label="订单时间">
      <div :class="$style['time-scope']">
        <el-date-picker type="date" placeholder="选择日期" v-model="filterForm.date1" style="width: 100%;"></el-date-picker>
        <span class="bound">&nbsp;—&nbsp;</span>
        <el-time-picker type="fixed-time" placeholder="选择时间" v-model="filterForm.date2" style="width: 100%;"></el-time-picker>
      </div>
    </el-form-item>
    <el-form-item>
      <el-button type="primary">筛选</el-button>
      <el-button type="primary">导出</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-lot-list-filter-form'

export default {
  name: 'pt-lot-list-filter-form',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  data () {
    return {
      filterForm: {
        name: '',
        date1: '',
        date2: ''
      }
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-lot-list-filter-form,
.time-scope{
  display: flex;
}
</style>
